/*@ngInject*/
const KeepAliveController = function ($scope, $element, $interval, browserUtil, coreConstant, coreMediator, preferenceModel, keepAliveMediator, umsLog) {

    $element.addClass('keepAlive');

    var pingInterval,
        intervalObject = null,
        isEdge = browserUtil.isEdge();

    function init() {
        coreMediator.loadDefaultPreferences().then(function () {
            var keepAliveIntervalInMillisecondsPreference;
            if (isEdge) {
                pingInterval = coreConstant.EDGE_KEEP_ALIVE_PING_INTERVAL;
                keepAliveIntervalInMillisecondsPreference = preferenceModel.get('system.edgeKeepAliveIntervalInMilliseconds');
            } else {
                pingInterval = coreConstant.DEFAULT_KEEP_ALIVE_PING_INTERVAL;
                keepAliveIntervalInMillisecondsPreference = preferenceModel.get('system.keepAliveIntervalInMilliseconds');
            }
            if (!isNaN(keepAliveIntervalInMillisecondsPreference)) {
                pingInterval = _.parseInt(keepAliveIntervalInMillisecondsPreference);
            }
        });
    };

    function start() {
        if (_.isNil(intervalObject)) {
            intervalObject = $interval(function () {
                keepAliveMediator.keepAliveDisconnectOnError();
            }, pingInterval);
        }
    }

    function stop() {
        if (!_.isNil(intervalObject)) {
            $interval.cancel(intervalObject);
            intervalObject = null;
        }
    }

    $scope.$on(coreConstant.event.KEEPALIVE_PING, function () {
        start();
    });

    $scope.$on(coreConstant.event.STOP_KEEPALIVE_PING, function () {
        stop();
    });

    $scope.$on('$destroy', function () {
        stop();
    });

    init();
};

angular.module('umCore')
    .controller('keepAliveController', KeepAliveController);
